<template>
  <div class="login-container">
    <div class="center">
      <div class="ykw">登录</div>
      <div class="login-form">
        <el-form ref="form" :model="formData" label-width="0" :rules="rules">
          <el-form-item prop="account">
            <el-input v-model="formData.mobile" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input class="yan-input" v-model="formData.code" placeholder="请输入验证码">
              <template slot="append">
                <el-link :disabled="isDisabled" :underline="false" @click="getCode" class="yan_code">
                  {{ codeStr }}
                </el-link>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="login-btn">
              <el-button type="primary" @click="onSubmit">登录</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoginCodeAPI } from './api';

export default {
  name: 'Login',

  data() {
    return {
      isDisabled: false,
      imgCode: '',
      formData: {
        code: '',
        mobile: '',
      },
      rules: {},
      codeStr: '获取验证码'
    }
  },

  mounted() {},

  methods: {
    onSubmit() {
      this.$store.dispatch('Login', this.formData).then(() => {
        this.$router.push({ path: '/home' })
        sessionStorage.removeItem('keyPath')
      })
    },
     async getCode() {
      if(!this.formData.mobile) return this.$message.error('手机号必填')
      await getLoginCodeAPI(this.formData.mobile)
      this.isDisabled = true
      let sec = 59
      this.codeStr = `重发（${sec}s）`
      this.timer = setInterval(() => {
        sec = sec - 1
        this.codeStr = `重发（${sec}s）`
        if (sec <= 0) {
          this.codeStr = '获取验证码'
          this.isDisabled = false
          clearInterval(this.timer)
        }
      }, 1000)
    },
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  flex: 1;
  background: url('/bg.jpg') no-repeat;
  background-size: cover;
  background-position: center;

  .center {
    width: 534px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: #e6e5dcb3;
    padding: 85px 40px;
    border-radius: 16px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);

    .logo-img {
      display: flex;
      align-items: center;
      margin-bottom: 32px;
      .left-logo {
        margin-right: 12px;
        width: 256px;
        height: 102px;
        img {
          width: 256px;
          margin-left: -40px;
        }
      }
      .right-txt {
        width: 78px;
        height: 24px;
        img {
          width: 78px;
          height: 24px;
        }
      }
    }
    .ykw {
      color: #1a1e25;
      line-height: 32px;
      text-align: center;
      margin-bottom: 80px;
      font-size: 30px;
    }
    .ykw-en {
      line-height: 32px;
      font-weight: 500;
      font-size: 16px;
      color: #788692;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .login-form {
      .tip-icon {
        display: flex;
        align-items: center;
        line-height: 30px;
        color: #1a1e25;
        font-size: 14px;
        img {
          margin-right: 8px;
        }
      }
      .yzm-img {
        height: 48px;
      }
      .yan-input /deep/ {
        .el-input__inner {
          border-right: none;
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
          border-top-right-radius: 0!important;
          border-bottom-right-radius: 0!important;
        }
        .el-input-group__append {
          background-color: #fff;
          border-left: none;
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
          border-color: #333333;
        }
        .yan_code {
          font-size: 16px;
          border-left: 1px solid #ccc;
          padding-left: 20px;
          color: #333333;
        }
      }
      .el-form /deep/ {
        .el-input__inner {
          height: 48px;
          border-radius: 8px;
          border-color: #333333;
        }
        .login-btn {
          display: flex;
          margin-top: 40px;
          .el-button {
            flex: 1;
            height: 48px;
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            background-color: #333333;
            border-color: #333333;
            border-radius: 8px;
          }
        }
        .reset-btn {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 12px;
        }
      }
    }
  }
}
</style>
